export default "__VITE_ASSET__CGEZSWah__"